import type { Fetcher } from 'swr';
import useSWR from 'swr';

import { propertiesContractsList } from '~/data/generated/endpoints/properties/properties';
import { parseApiResponse } from '~/data/parseApiResponse';
import { type PropertyContract, propertyContractSchema } from '~/data/schemas/contract';

/**
 * The key used to revalidate the contracts list.
 */
export const PROPERTY_CONTRACTS_KEY = 'property-contracts';

const REVALIDATION_KEY = PROPERTY_CONTRACTS_KEY;

const propertyContractsListFetcher: Fetcher<
  PropertyContract[],
  [typeof REVALIDATION_KEY, propertyId: string]
> = async ([_, propertyId]) => {
  // Unpaginated nested list, so the endpoint returns a bare PropertyContract[]
  // rather than the paginated envelope the generated type describes (AMP-504).
  const { data } = await propertiesContractsList(propertyId);
  const results = Array.isArray(data) ? data : data?.results;
  return parseApiResponse(propertyContractSchema.array(), results, 'Property Contract');
};

export default function usePropertyContracts(propertyId?: string) {
  const { data, error, isLoading } = useSWR(
    propertyId ? [REVALIDATION_KEY, propertyId] : null,
    propertyContractsListFetcher,
    {},
  );

  return {
    contracts: data ?? [],
    error,
    isLoading,
  };
}
